import _ from 'lodash'

export default {
	methods: {
		// Helper methods to easily mark fields for errors
		// This is the alternative to using formulate and only needed for those fields
		invalidDirty: _.debounce(function (fieldName) {
			this.$store.commit('setInvalidDirty', fieldName)
		}, 300),
		invalidState (fieldName) {
			return this.$store.getters.invalidFieldState(fieldName)
		},
		invalidError (fieldName) {
			return this.$store.getters.invalidFieldError(fieldName)
		},
		invalidReset (fieldName) {
			this.$store.commit('unsetInvalid', fieldName)
		},
		/**
		 * The field is required and must have any value
		 *
		 * @param validationName
		 * @param fieldName
		 * @param value
		 */
		validateRequired (validationName, fieldName, value) {

			if (value === '' || value === undefined || value === null) {
				this.$store.commit('setInvalid', {
					field: fieldName,
					error: validationName + ' is required.'
				})
			} else {
				this.invalidReset(fieldName)
			}
		},
		/**
		 * The field is required and must be a numeric value within a set range
		 *
		 * @param validationName
		 * @param fieldName
		 * @param value
		 * @param min
		 * @param max
		 */
		validateRange (validationName, fieldName, value, min = 0, max = 999) {
			if (value === '' || value === undefined || value === null) {
				this.$store.commit('setInvalid', {
					field: fieldName,
					error: validationName + ' is required.'
				})

				return
			}

			const numericValue = typeof value === 'string'
				? parseFloat(value.replace(/\D/g, ''))
				: value

			if (numericValue < min) {
				this.$store.commit('setInvalid', {
					field: fieldName,
					error: validationName + ' must be at least ' + min + '.'
				})

				return
			}

			if (numericValue > max) {
				this.$store.commit('setInvalid', {
					field: fieldName,
					error: validationName + ' cannot be more than ' + max + '.'
				})

				return
			}

			this.invalidReset(fieldName)
		}
	}
}
